export default {
  "errorInterceptor.error.generic.title": {
    en: "Error!",
    es: "¡Error!",
  },
  "errorInterceptor.error.generic.message": {
    en: "Oops, an error occurred!",
    es: "¡Ups, ha ocurrido un error!",
  },
  "errorInterceptor.error.lastChanges.message": {
    en: "We had a problem saving latest changes. Please refresh your browser; If it doesn't work, contact our support team.",
    es: "Hemos tenido un problema para guardar los últimos cambios. Por favor, actualiza el navegador; si no funciona, contacta con nuestro equipo de soporte.",
  },

  "quoteLineFactory.checkPriceExceedMax.error": {
    en: "Rate __$1__ could not be changed to __$2__ because it is over the maximum price allowed.",
    es: "La tarifa __$1__ no se ha podido convertir a __$2__ porque excede el máximo precio permitido.",
  },

  "quoteSectionSnapshot.placeholder.header1": {
    en: "Header 1",
    es: "Título",
  },
  "quoteSectionSnapshot.placeholder.header2": {
    en: "Header 2",
    es: "Subtítulo",
  },
  "quoteSectionSnapshot.placeholder.paragraph": {
    en: "Paragraph",
    es: "Párrafo",
  },
  "quoteSectionSnapshot.placeholder.paragraph.text": {
    en: "Any clarification? Type it here!",
    es: "¿Alguna aclaración? ¡Escríbela aquí!",
  },

  "tariffFactory.checkPriceExceedMax.error": {
    en: "Rate __$1__ could not be changed to __$2__ because it is over the maximum price allowed.",
    es: "La tarifa __$1__ no se ha podido convertir a __$2__ porque excede el máximo precio permitido.",
  },
};
